export default [
  {
    path: '/maintenance-remind',
    component: () => import('@/views/maintenance/remind.vue'),
    name: 'maintenance-remind',
    props: true,
    meta: {
      title: '保养提醒',
      backgroundClass: 'bg-gray',
      keepAlive: true,
    },
  },
  // 保养提醒说明
  {
    path: '/maintenance-instruction',
    component: () => import('@/views/maintenance/instruction.vue'),
    name: 'maintenance-instruction',
    props: true,
    meta: {
      title: '保养提醒说明',
      backgroundClass: 'bg-white',
      keepAlive: true,
    },
  },
];
